import { MutationTree } from 'vuex'
import { ApplicationState } from '@/store/index'

export default {
  initialized: (state: ApplicationState, initialized: boolean) => { state.initialized = initialized }
} as MutationTree<ApplicationState>
